import { Card, Inline, Skeleton, Stack } from '@cortex/ui';

/**
 * Skeleton loader for project cards.
 * Shows a placeholder card during data fetch that matches the ProjectCard layout.
 *
 * Used on the Dashboard page and Projects list page.
 */
export function ProjectCardSkeleton() {
  return (
    <Card className="p-4">
      <Stack gap="sm">
        <Inline justify="between" align="start">
          <Inline gap="sm">
            <Skeleton variant="circle" width={20} height={20} />
            <Skeleton variant="rectangle" width={120} height={20} />
          </Inline>
          <Skeleton variant="rectangle" width={60} height={24} />
        </Inline>
        <Skeleton variant="rectangle" width="100%" height={40} />
        <Skeleton variant="rectangle" width="100%" height={8} />
        <Inline justify="between" className="border-border border-t pt-3">
          <Inline gap="md">
            <Skeleton variant="rectangle" width={40} height={16} />
            <Skeleton variant="rectangle" width={40} height={16} />
          </Inline>
          <Inline gap="none" className="-space-x-2">
            <Skeleton variant="circle" width={24} height={24} />
            <Skeleton variant="circle" width={24} height={24} />
          </Inline>
        </Inline>
      </Stack>
    </Card>
  );
}
